<template>
    <li
        class="house-slider-item layout6"
        :class="{ mobile: isMobile }"
        :title="address"
        @click="openDetail(link, $event)"
    >
        <article>
            <div class="house-imgs">
                <a
                    :href="linkData.href"
                    :target="linkData.target"
                    :aria-label="linkData['aria-label']"
                    :self="linkData.self"
                >
                    <site-img
                        :src="firstImage"
                        :errorImg="defHouseImg"
                        dir="width"
                    ></site-img>
                    <house-mask
                        v-if="isShowMask"
                        display="fill-up"
                    ></house-mask>
                </a>
                <p v-if="soldDate" :class="['house-sold-date', statusOrigin]">
                    <only-client>
                        <span>{{
                            $t('md-house.soldOn', {
                                soldDate: $ft.formatDate(soldDate, 'MM/dd/yyyy')
                            })
                        }}</span>
                    </only-client>
                </p>
            </div>
            <div class="house-info">
                <div class="house-price-wrap">
                    <title-mask-v2 v-if="isShowMask"></title-mask-v2>
                    <no-disclosure
                        v-else-if="!!house.nodisclosureDes || hidePrice"
                        :des="
                            hidePrice
                                ? $t('md-house.nondisclosure')
                                : house.nodisclosureDes
                        "
                    ></no-disclosure>
                    <template v-else-if="soldDate">
                        <span class="house-sold-price">
                            {{ markPrice.replace(/\s/g, '') }}
                        </span>
                        <div class="sold-price-trend">
                            <span
                                class="house-initial-price"
                                v-if="showAllPrice && initialPrice"
                            >
                                {{ $ft.trim(initialPrice) }}
                            </span>
                            <HouseTrend
                                v-if="showAllPrice && trend"
                                :trendStatus="trendStatus"
                                :trend="trend"
                            />
                        </div>
                    </template>
                    <div v-else class="house-price">
                        {{ price.replace(/\s/g, '') }}
                    </div>
                </div>
                <p class="detail">
                    <span
                        :class="['vertical-line', `house-${item.key}`]"
                        v-for="item in basic"
                        :key="item.key"
                    >{{ item.text }}</span
                    >
                </p>
                <h3 class="address" v-if="address">
                    <a
                        :href="linkData.href"
                        :target="linkData.target"
                        :aria-label="linkData['aria-label']"
                        :self="linkData.self"
                    >{{ address }}</a
                    >
                </h3>
                <div class="mls-box">
                    <div
                        class="mls-provided"
                    >
                        <p v-if="showMls" class="house-mls-id">
                            MLS# {{ mlsid }}
                        </p>
                        <p
                            v-if="provided && !isShowMask"
                            class="desc ws-pre-wrap"
                        >
                            {{ provided }}
                        </p>
                    </div>
                    <site-img
                        v-if="mlsLogo"
                        class="house-mls-logo"
                        :src="mlsLogo"
                        :alt="mlsAlt"
                        :size="30"
                        dir="height"
                    />
                </div>
            </div>
        </article>
        <schema-info :info="seoSchema" v-if="seoSchema" />
    </li>
</template>
<script>
import HouseItem from '../house-item.js';
import OnlyClient from '@/components/global/only-client.vue';
export default {
    components: { OnlyClient },
    mixins: [HouseItem],
    data() {
        return {
            // isShowMask: true
        }
    }
};
</script>
<style lang="scss">
@import '@/theme/media.scss';
@import '@/theme/mixin.scss';
.house-slider-item.layout6 {
    list-style: none;
    width: 100%;
    height: 100%;
    border: 1px solid rgba(218, 218, 218, 0.5);
    padding: 15px;

    > article {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .house-imgs {
        width: 100%;
        height: 224px;
        position: relative;
        flex-shrink: 0;
        overflow: hidden;
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform 0.3s ease;
            &:hover {
                transform: scale(1.1);
            }
        }
        .house-sold-date {
            position: absolute;
            left: 20px;
            top: 20px;
            z-index: 2;
            span {
                display: inline-block;
                font-family: var(--font-normal);
                font-size: 12px;
                font-weight: 700;
                height: 20px;
                line-height: 20px;
                padding: 0 5px;
                border-radius: 0;
                color: #fff;
                background-color: #505050;
            }
        }
    }
    .house-info {
        padding-top: 15px;
        display: flex;
        flex-direction: column;

        .house-price-wrap {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            .nodisclosure {
                .dollar,
                .secret {
                    color: var(--color-success);
                }
            }
            .house-sold-price,
            .house-price {
                color: var(--g-primary-color);
                font-weight: 700;
                font-size: 24px;
                font-family: var(--mg-title-font);
                height: 36px;
                line-height: 36px;
            }
            .sold-price-trend {
                display: flex;
                height: 20px;
            }
            .house-initial-price {
                color: var(--g-tip-color);
                font-size: 16px;
                line-height: 20px;
                font-weight: 400;
                margin-left: 10px;
                text-decoration: line-through;
            }
        }
        .detail,
        .address {
            margin-top: 5px;
            color: var(--g-text-color);
            font-family: var(--font-title);
            font-size: 12px;
            font-weight: 400;
            line-height: 18px;
            text-align: left;
            @include webkitBox(2);
        }
        .detail {
            .vertical-line:after {
                content: '|';
                display: inline;
                margin: 0 8px;
                color: var(--g-text-color);
            }
            .vertical-line:nth-last-child(1):after {
                content: '';
            }
        }
        .mls-box {
            margin-top: 15px;
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            .mls-provided {
                flex: 1;
            }
            .house-mls-id,
            .desc {
                font-weight: 400;
                font-size: 12px;
                line-height: 18px;
                color: var(--g-tip-color);
                @include webkitBox(2);
            }
            @media (max-width: 1200px) {
                .desc {
                    @include webkitBox(1);
                }
            }

            .house-mls-logo {
                height: 18px;
                object-fit: cover;
                margin-left: 20px;
            }
        }
    }

    &:hover {
        box-shadow: 0px 4px 20px 0px #1919191A;
    }

    &.mobile {
        height: auto;
        margin-bottom: 15px;
        .house-info {
            .house-mls-logo {
                height: 20px;
            }
        }
    }
}
.item-box:last-child {
    .house-slider-item.layout6 {
        &.mobile {
            margin-bottom: 20px;
        }
    }
}
</style>
